import _slicedToArray from "/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
// Copyright 2017-2022 @polkadot/types-codec authors & contributors
// SPDX-License-Identifier: Apache-2.0
export function typesToMap(registry, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      Types = _ref2[0],
      keys = _ref2[1];

  var result = {};

  for (var i = 0; i < keys.length; i++) {
    result[keys[i]] = registry.getClassName(Types[i]) || new Types[i](registry).toRawType();
  }

  return result;
}